import { HEADER_BLOCK } from 'ricos-content';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const DOC_STYLE_TYPES = {
  P: "paragraph",
  H1: "headerOne",
  H2: "headerTwo",
  H3: "headerThree",
  H4: "headerFour",
  H5: "headerFive",
  H6: "headerSix"
};
const DRAFT_TO_DOC_TYPE = {
  [HEADER_BLOCK.ONE]: "headerOne",
  [HEADER_BLOCK.TWO]: "headerTwo",
  [HEADER_BLOCK.THREE]: "headerThree",
  [HEADER_BLOCK.FOUR]: "headerFour",
  [HEADER_BLOCK.FIVE]: "headerFive",
  [HEADER_BLOCK.SIX]: "headerSix",
  [HEADER_BLOCK.PARAGRAPH]: "paragraph"
};
const DRAFT_TO_DOC_TYPE_WITH_LISTS = __spreadProps(__spreadValues({}, DRAFT_TO_DOC_TYPE), {
  "ordered-list-item": "paragraph",
  "unordered-list-item": "paragraph"
});

export { DOC_STYLE_TYPES, DRAFT_TO_DOC_TYPE, DRAFT_TO_DOC_TYPE_WITH_LISTS };
//# sourceMappingURL=editorTypes.js.map
